import { ImageResize } from './image.interfaces';
import css from "./image.module.css";
export const resizeToCss = {
    [ImageResize.fill]: css.fill,
    [ImageResize.fit]: css.fit,
};
